export default "__VITE_ASSET__0QJy7c94__"